export const insertText = (textarea: HTMLTextAreaElement, text: string) => {
  const start = textarea.selectionStart ?? textarea.value.length;
  const end = textarea.selectionEnd ?? start;
  const value = textarea.value.slice(0, start) + text + textarea.value.slice(end);

  textarea.value = value;
  textarea.focus();
  textarea.setSelectionRange(start + text.length, start + text.length);

  return value;
};
